<template>
  <router-view></router-view>
</template>

<script>
  export default {
    name: 'Company',
  }
</script>
